import { useEffect, useRef } from "react";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import { STREETS_STYLE } from "@/components/map/mapStyles";

export const VisitorMap = ({ visitors }) => {
  const mapEl = useRef(null);
  const map = useRef(null);
  useEffect(() => {
    const points = visitors.filter((visitor) => visitor.last_location);
    if (!mapEl.current || !points.length) return undefined;
    const instance = new maplibregl.Map({ container: mapEl.current, style: STREETS_STYLE, center: [points[0].last_location.lng, points[0].last_location.lat], zoom: 9, interactive: true, attributionControl: { compact: true } });
    const bounds = new maplibregl.LngLatBounds();
    points.forEach((visitor) => {
      const { lng, lat } = visitor.last_location;
      new maplibregl.Marker({ color: "#bb8b14" }).setLngLat([lng, lat]).setPopup(new maplibregl.Popup({ offset: 18 }).setText(visitor.visitor_name || "Anonymous visitor")).addTo(instance);
      bounds.extend([lng, lat]);
    });
    instance.on("load", () => { if (points.length > 1) instance.fitBounds(bounds, { padding: 45, maxZoom: 12 }); });
    map.current = instance;
    return () => { instance.remove(); map.current = null; };
  }, [visitors]);
  if (!visitors.some((visitor) => visitor.last_location)) return <div className="grid min-h-44 place-items-center border border-dashed border-neutral-300 text-center text-sm text-neutral-500" data-testid="visitor-map-empty">Map pins appear only when a visitor chooses to share their location.</div>;
  return <div ref={mapEl} className="min-h-44 overflow-hidden border border-neutral-200" data-testid="visitor-map" />;
};